import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Navigate } from "@ngxs/router-plugin";
import {
  Actions,
  ofActionErrored,
  ofActionSuccessful,
  Store,
} from "@ngxs/store";
import { AlertService } from "src/app/services/alert.service";
import { DataService } from "src/app/services/data.service";
import { AddToCart, ReduceToCart } from "src/app/states/actions/user.actions";
import { UserState } from "src/app/states/user.state";
@Component({
  selector: "app-product-result",
  templateUrl: "./product-result.component.html",
  styleUrls: ["./product-result.component.less"],
})
export class ProductResultComponent {
  @Input() selected;
  @Output() select = new EventEmitter();
  @Input() feature;
  @Input() showMessages = true;
  awaitAdd = false;
  loadedImage = false;

  constructor(
    private store: Store,
    private actions: Actions,
    private _alertService: AlertService,
    private _dataService: DataService
  ) {}

  goToFeature = (id) => this.store.dispatch(new Navigate([`/product/${id}`]));

  addToCart = (feature, event) => {
    this._dataService.displayLoading();
    event.stopPropagation();
    if (!this.store.selectSnapshot(UserState.UID)) {
      this.store.dispatch(new Navigate(["/profile/login"]));
      this._dataService.displayLoading(false);

      return this._alertService.openSnackBar(
        "Intenta registrarte primero",
        "warn"
      );
    } else {
      this.select.emit(feature);
      this.awaitAdd = true;
      this.store.dispatch(new AddToCart(feature));
      this.handler(AddToCart, "Agregado al carrito");
    }
  };

  handler = (action, msg?, err = "Error de conexión") => {
    let errorSubs;
    let subs;
    errorSubs = this.actions.pipe(ofActionErrored(action)).subscribe(() => {
      this._dataService.displayLoading(false);
      this.awaitAdd = false;
      this._alertService.openSnackBar(err, "error");
      errorSubs.unsubscribe();
      subs.unsubscribe();
    });
    subs = this.actions.pipe(ofActionSuccessful(action)).subscribe(() => {
      this._dataService.displayLoading(false);
      this.showMessages && msg ? this._alertService.openSnackBar(msg) : null;
      this.awaitAdd = false;
      errorSubs.unsubscribe();
      subs.unsubscribe();
    });
  };

  reduceToCart = (feature, event) => {
    event.stopPropagation();
    this.select.emit(feature);
    this.awaitAdd = true;
    this.handler(ReduceToCart, null);
    this.store.dispatch(new ReduceToCart(feature));
  };

  onImageLoad = () => (this.loadedImage = true);
}
